# These filters must be placed at the shared page level, 
# since the clickers are OUTSIDE the individual main settings pages

class DF.Views.Filters extends Backbone.Enhanced.View
  
  el: 'body'

  events:
    'click .filters.timeframe .button.filter' : '_onTimeframeClick'
    'click .filters.performance .button.filter' : '_onPerformanceChartTypeClick'
    'click .filters.profile .button.filter' : '_onProfileClick'
    'click .filters.notification-image .button.filter' : '_onNotificationClick'

  _resetButtons: (e) ->
    all_buttons = $(e.target).parents('.filters').find('.button.filter')
    all_buttons.removeClass('active')
    $(e.target).addClass('active')

  _onTimeframeClick: (e) ->
    @_resetButtons(e)
    DF.Events.trigger('filter:timeframe', e)

  _onPerformanceChartTypeClick: (e) ->
    @_resetButtons(e)
    DF.Events.trigger('filter:performance', e)

  _onProfileClick: (e) ->
    @_resetButtons(e)
    item_id = $(e.target).data('audience-profile-id')
    DF.Events.trigger('filter:profile', item_id)

  _onNotificationClick: (e) ->
    @_resetButtons(e)
    DF.Events.trigger('filter:notification:image', e)

module.exports = DF.Views.Filters
